import TextInput from "../TextInput";
import Button from "../Button";

const CheckEmail = ({ validateEmail, email, handleEmailCheck }) => {
  return (
    <>
      <p className="fw600">
        Antes de empezar, necesitamos que nos indiques tu e-mail
      </p>
      <TextInput
        placeholder={"Email"}
        type={"text"}
        onChange={(e) => validateEmail(e)}
      />
      <Button
        variant={`login-btn ${email.length !== 0 ? "enabled" : ""}`}
        isDisabled={email.length === 0}
        onClick={handleEmailCheck}
      >
        Continuar
      </Button>
    </>
  );
};

export default CheckEmail;
